import React from 'react';

import * as styles from './toolbar.styles';

const Toolbar: React.FC = () => (
  <div css={styles.container} role="navigation">
    <span css={styles.copyright}>Domain Developer Portal</span>
    <ul css={styles.items}>
      <li css={styles.item}>
        <a css={styles.link} href="/docs/latest/support">
          Support
        </a>
      </li>
      <li css={styles.item}>
        <a
          css={styles.link}
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.domain.com.au/group/api-terms-and-conditions/"
        >
          Terms &amp; Conditions
        </a>
      </li>
      <li css={styles.item}>
        <a css={styles.link} href="/docs/latest/support/policies">
          Policies
        </a>
      </li>
      <li css={styles.item}>
        <a css={styles.link} href="//www.domain.com.au/">
          Domain.com.au
        </a>
      </li>
    </ul>
  </div>
);

export default Toolbar;
